import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http';
import { DashboardRoutes } from './dashboard.routing'
import { AdminViewComponent } from './adminView/adminView.component'
import { DashboardService } from "./dashboard.service";
import { TooltipModule } from "ngx-tooltip";
import { StoresComponent } from './stores/stores.component';
import { AdminPlanComponent } from './admin-plan/admin-plan.component'
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { AdminLeadComponent } from './admin-lead/admin-lead.component';
import { AdminMetricsComponent } from './admin-metrics/admin-metrics.component';
import { AdminFinanceComponent } from './admin-finance/admin-finance.component';
import { AdminPipeComponent } from './admin-pipe/admin-pipe.component';
import { CardPipePolenComponent } from './shared/card-pipepolen/card-pipepolen.component';
import { AdminStatementEditComponent } from './admin-finance/admin-statementEdit/admin-statementEdit.component';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { AdministratorService } from '../administrator/administrator.service';
import { SharedModule } from '../shared/shared.module';
import { JunoService } from '../services/juno.service';
import { ProfileService } from '../profile/profile.service';
import { TagService } from '../services/tag.service';
import { HelperService } from '../services/helper.service';
import { PlanService } from '../services/plan.service';
import { StatementService } from '../services/statement.service';
import { NgxPaginationModule } from 'ngx-pagination'; // Módulo da dependência de paginação

@NgModule({
    imports: [
        CommonModule,
        DashboardRoutes,
        FormsModule,
        HttpClientModule,
        TooltipModule,
        NgxSmartModalModule.forRoot(),
        CurrencyMaskModule,
        SharedModule,
        NgxPaginationModule
    ],
    declarations: [
        CardPipePolenComponent,
        AdminViewComponent,
        StoresComponent,
        AdminPlanComponent,
        AdminLeadComponent,
        AdminMetricsComponent,
        AdminFinanceComponent,
        AdminPipeComponent,
        AdminStatementEditComponent
    ],
    providers: [
        DashboardService,
        ProfileService,
        AdministratorService,
        JunoService,
        TagService,
        HelperService,
        PlanService,
        StatementService,
    ]
})

export class DashboardModule { }
